<template>
	<inertia-head title="Register" />
	<form @submit.prevent="register">
		<div class="row">
			<div class="col-md-6">
				<div class="form-floating mb-4">
					<input
						id="firstname"
						v-model="form.firstname"
						:class="{ 'is-invalid': form.errors.firstname }"
						type="text"
						class="form-control"
						placeholder="Enter your email"
					/>
					<label class="form-label" for="firstname">First Name</label>
					<div v-if="form.errors.firstname" class="invalid-feedback">
						<i class="fa fa-exclamation-circle"></i>
						{{ form.errors.firstname }}
					</div>
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-floating mb-4">
					<input
						id="lastname"
						v-model="form.lastname"
						:class="{ 'is-invalid': form.errors.lastname }"
						type="text"
						class="form-control"
						placeholder="Enter your email"
					/>
					<label class="form-label" for="lastname">Last Name</label>
					<div v-if="form.errors.lastname" class="invalid-feedback">
						<i class="fa fa-exclamation-circle"></i>
						{{ form.errors.lastname }}
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-6">
				<div class="form-floating mb-4">
					<input
						id="email"
						v-model="form.email"
						:class="{ 'is-invalid': form.errors.email }"
						type="text"
						class="form-control"
						placeholder="Enter your email"
					/>
					<label class="form-label" for="email">Email address</label>
					<div v-if="form.errors.email" class="invalid-feedback">
						<i class="fa fa-exclamation-circle"></i>
						{{ form.errors.email }}
					</div>
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-floating mb-4">
					<flat-pickr
						id="birthdate"
						v-model="form.birthdate"
						:class="
							form.errors.birthdate
								? 'flatpickr-input is-invalid border-danger'
								: 'flatpickr-input'
						"
						class="form-control"
						placeholder="Enter your birthdate"
					/>
					<label class="form-label" for="birthdate">Birthdate</label>
					<div v-if="form.errors.birthdate" class="invalid-feedback">
						<i class="fa fa-exclamation-circle"></i>
						{{ form.errors.birthdate }}
					</div>
				</div>
			</div>
		</div>
		<div class="mb-4">
			<vue-tel-input
				v-model="form.phone"
				@input="onInput"
				defaultCountry="PH"
				mode="international"
				:class="{ 'is-invalid': form.errors.phone }"
				class="form-control"
			/>
			<div v-if="form.errors.phone" class="invalid-feedback">
				<i class="fa fa-exclamation-circle"></i>
				{{ form.errors.phone }}
			</div>
		</div>
		<div class="form-floating mb-4">
			<select
				v-model="form.subscription"
				:class="{ 'is-invalid': form.errors.subscription }"
				id="subscription"
				class="form-control"
				placeholder="Select Subscription"
			>
				<optgroup
					v-for="(
						subscriptionCollection, subscriptionCollectionAlias
					) in subscriptionCollections"
					:key="subscriptionCollectionAlias"
					:label="subscriptionCollectionAlias"
				>
					<option
						v-for="subscription in subscriptionCollection"
						:key="subscription.prod_id"
						:value="subscription.prod_id"
					>
						&#8369; {{ subscription.value }}
					</option>
				</optgroup>
			</select>
			<label class="form-label" for="subscription">Subscription</label>
			<div v-if="form.errors.subscription" class="invalid-feedback">
				<i class="fa fa-exclamation-circle"></i>
				{{ form.errors.subscription }}
			</div>
		</div>
		<div class="block block-rounded shadow">
			<div class="block-header">
				<h3 class="block-title">Payment Method</h3>
			</div>
			<div class="block-content">
				<div class="row">
					<div class="col-6">
						<div class="form-check form-block mb-4">
							<input
								v-model="form.payment_method"
								class="form-check-input"
								type="radio"
								v-bind:value="'card'"
								id="card"
								name="payment_method"
							/>
							<label class="form-check-label" for="card">
								<span class="d-flex align-items-center">
									<img
										class="img-fluid py-2"
										src="/media/logo/stripe-logo.png"
										alt=""
									/>
								</span>
							</label>
						</div>
					</div>
					<div class="col-6">
						<div class="form-check form-block mb-4">
							<input
								v-model="form.payment_method"
								class="form-check-input"
								type="radio"
								v-bind:value="'dragonpay'"
								id="dragonpay"
								name="payment_method"
							/>
							<label class="form-check-label" for="dragonpay">
								<span class="d-flex align-items-center">
									<img
										class="img-fluid"
										src="/media/logo/dragonpay-logo.png"
										alt=""
									/>
								</span>
							</label>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="form-floating mb-4">
			<input
				type="text"
				class="form-control"
				id="coupon_code"
				v-model="form.coupon_code"
				:class="{ 'is-invalid': form.errors.coupon_code }"
				placeholder="Enter your email"
			/>
			<label class="form-label" for="coupon_code">Coupon Code</label>
			<div v-if="form.errors.coupon_code" class="invalid-feedback">
				<i class="fa fa-exclamation-circle"></i>
				{{ form.errors.coupon_code }}
			</div>
		</div>
		<!-- <div v-if="form.payment_method == 'card'" class="form-group mb-4">
			<stripe @accept-token="acceptToken" ref="stripe" />
			<div v-if="form.errors.card" class="invalid-feedback d-block">
				<i class="fa fa-exclamation-circle"></i>
				{{ form.errors.card }}
			</div>
		</div>
		<div v-if="form.payment_method === 'card'" class="mb-4">
			<div class="form-check">
				<input
					v-model="form.userAgree"
					class="form-check-input"
					type="checkbox"
					:value="true"
					id="register3-terms"
					name="register3-terms"
				/>
				<label class="form-check-label" for="register3-terms">
					I agree with the terms & conditions.
				</label>
			</div>
		</div> -->
		<div class="row g-sm mb-4">
			<div class="col-12 mb-2">
				<button
					type="submit"
					class="btn btn-lg btn-alt-primary w-100 py-3 fw-semibold"
					data-toggle="click-ripple"
					:disabled="
						form.processing ||
						(form.payment_method == 'card' && (!form.token || !form.userAgree))
					"
				>
					<div
						v-if="form.processing"
						class="spinner-border spinner-border-sm text-dark"
						role="status"
					>
						<span class="sr-only">Loading...</span>
					</div>
					<span v-if="!form.processing">Next</span>
				</button>
			</div>
			<div class="col-sm-6 mb-1">
				<inertia-link href="/" class="btn btn-alt-secondary w-100">
					Sign in
				</inertia-link>
			</div>
			<div class="col-sm-6 mb-1">
				<inertia-link
					href="/reset-password"
					class="btn btn-alt-secondary w-100"
				>
					Reset password
				</inertia-link>
			</div>
		</div>
	</form>
	<div class="block-content text-center">
		<img
			src="/media/logo/poweredbystripe.png"
			alt="security"
			style="width: 150px"
		/>
		<div class="mt-3">Your referring affiliate is: {{ sponsor ?? 'None' }}</div>
	</div>

	<terms-and-conditions ref="termsModal" />
</template>

<script>
import { onMounted, ref, watch } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import Stripe from '../../Shared/Components/Stripe'
import GuestLayout from '../../Layouts/GuestLayout'
import TermsAndConditions from '../../Shared/Components/Modals/TermsAndConditions'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	layout: GuestLayout,
	components: {
		Stripe,
		TermsAndConditions,
	},
	props: {
		subscriptionCollections: Object,
		sponsor: String,
		c_source: String,
		flash: Object,
	},
	setup(props) {
		onMounted(() => {
			fbq('track', 'PageView')
		})

		const termsModal = ref(null)

		const stripe = ref(null)

		const form = useForm({
			firstname: null,
			lastname: null,
			email: null,
			phone: null,
			country: null,
			countryCallingCode: null,
			birthdate: null,
			subscription: null,
			coupon_code: null,
			payment_method: 'card',
			token: null,
			userAgree: false,
			c_source: props.c_source,
		})

		const onInput = (phone, phoneObject, input) => {
			if (phoneObject?.formatted) {
				form.phone = phoneObject.number
				form.country = phoneObject.countryCode
				form.countryCallingCode = phoneObject.countryCallingCode
			}
		}

		const register = async () => {
			if (form.payment_method === 'card' && !form.recentlySuccessful) {
				stripe.value.generateToken()
				form.token = stripe.value.token
			}

			form.processing = true
			setTimeout(() => form.post('/register', { preserveScroll: true }), 500)
		}

		const acceptToken = (token) => {
			form.token = token
		}

		watch(
			() => form.payment_method,
			(payment_method) => {
				if (payment_method == 'dragonpay') form.token = null
			}
		)

		watch(
			() => form.userAgree,
			(userAgree) => {
				if (userAgree) termsModal.value.toggleModal()
			}
		)

		return {
			form,
			termsModal,
			stripe,
			onInput,
			register,
			acceptToken,
		}
	},
}
</script>
